import { axios } from './index';


export const postEmail = async (name, emailAddress, message) => {
    const email = { 
        'name': name,
        'sender_email_address': emailAddress,
        'message': message
    };

    await axios.post('/email/send', email)
}